import { h, Fragment } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import { plusDrawn } from "../helpers/icons";
import QuickBuySize from "./quick-buy-size";

export default function QuickBuy({ product, open }) {
  const [wasExpanded, setWasExpanded] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const quickBuyRef = useRef(null);
  const quickBuyButtonRef = useRef(null);

  useEffect(() => {
    setExpanded(false);
  }, [product]);

  useEffect(() => {
    const closeEsc = (e) => {
      if (e.key === "Escape" && expanded) {
        setExpanded(false);
      }
    };

    document.addEventListener("keydown", closeEsc);

    try {
      if (expanded) {
        quickBuyRef?.current.querySelector("button").focus();
        setWasExpanded(true);
      }
      if (!expanded && wasExpanded) {
        setWasExpanded(false);
        quickBuyButtonRef?.current.focus();
      }
    } catch (error) {
      console.log("Error focusing quickbuy", error);
    }

    return () => document.removeEventListener("keydown", closeEsc);
  }, [expanded, quickBuyRef]);

  if (!product) return null;

  return (
    <>
      <div className="quick-buy">
        <button
          className={`quick-buy__button quick-buy__button--expand ${
            expanded ? "quick-buy__button--hidden" : ""
          }`}
          onClick={() => setExpanded(true)}
          onFocus={() => setExpanded(false)}
          // accessiBe breaks things by applying a tabindex="-1" because it thinks this button is hidden
          tabindex
          ref={quickBuyButtonRef}
        >
          <span className="visually-hidden">Open Quick Buy</span>
          {plusDrawn}
        </button>
      </div>
      {expanded && (
        <div
          ref={quickBuyRef}
          className="quick-buy"
          style={{ "--total": product.variants.length }}
        >
          {product.variants.map((variant, index) => (
            <QuickBuySize variant={variant} index={index} />
          ))}
        </div>
      )}
    </>
  );
}
